import { Button } from '@/components/ui/button'
import useModalStore from '@/stores/modalStore'
import { ArrowRight, Clock } from 'lucide-react'
import { ScrollReveal } from '@/components/ui/scroll-reveal'

export const CtaSection = () => {
  const { openModal } = useModalStore()

  return (
    <section id="cta" className="py-24 bg-white">
      <div className="container px-4 md:px-6">
        <ScrollReveal>
          <div className="bg-primary rounded-3xl p-8 md:p-16 text-center text-primary-foreground shadow-2xl relative overflow-hidden">
            <div className="absolute top-0 right-0 w-64 h-64 bg-white/10 rounded-full blur-3xl -mr-16 -mt-16 pointer-events-none" />
            <div className="absolute bottom-0 left-0 w-64 h-64 bg-white/10 rounded-full blur-3xl -ml-16 -mb-16 pointer-events-none" />

            <div className="relative z-10 max-w-3xl mx-auto space-y-8">
              <div className="inline-flex items-center justify-center p-3 bg-white/10 rounded-full mb-4">
                <Clock className="w-8 h-8 text-white" />
              </div>

              <h2 className="text-3xl md:text-5xl font-bold leading-tight">
                Quanto tempo e dinheiro perdes em tarefas manuais?
              </h2>

              <p className="text-xl text-primary-foreground/90">
                Agora imagina uma aplicação com automação e inteligência
                artificial a trabalhar todos os dias, sem erros, sem pausas e
                sem férias.
              </p>

              <div className="pt-4">
                <Button
                  size="lg"
                  variant="secondary"
                  className="h-16 px-10 text-lg font-bold shadow-lg hover:bg-white hover:text-primary transition-all scale-100 hover:scale-105"
                  onClick={openModal}
                >
                  Pedir demonstração
                  <ArrowRight className="ml-2 h-6 w-6" />
                </Button>
              </div>
            </div>
          </div>
        </ScrollReveal>
      </div>
    </section>
  )
}
